import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  People,
  Security,
  Settings as SettingsIcon,
  Person,
} from '@mui/icons-material';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';
import ModuleManagement from './ModuleManagement';
import Profile from './Profile';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = [
    { label: 'Users Management', icon: <People />, component: <UserManagement /> },
    { label: 'Roles Management', icon: <Security />, component: <RoleManagement /> },
    { label: 'Modules Management', icon: <SettingsIcon />, component: <ModuleManagement /> },
    { label: 'Profile', icon: <Person />, component: <Profile /> },
  ];

  return (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh',
      backgroundColor: '#f0f9ff' // Light blue background
    }}>
      {/* Left Sidebar - Settings Menu */}
      <Box sx={{ 
        width: 280, 
        backgroundColor: '#f0f9ff', // Light blue background
        borderRight: '1px solid #e5e7eb',
        p: 3,
      }}>
        <Typography variant="h4" sx={{ 
          fontWeight: 'bold', 
          color: '#374151', 
          mb: 2,
          fontSize: '1.5rem'
        }}>
          Settings
        </Typography>
        
        <Typography variant="body2" sx={{ 
          color: '#6b7280', 
          mb: 3,
          fontSize: '0.875rem'
        }}>
          Sub Menu
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {tabs.map((tab, index) => (
            <Button
              key={index}
              variant="text"
              startIcon={tab.icon}
              onClick={() => setActiveTab(index)}
              sx={{ 
                justifyContent: 'flex-start', 
                textAlign: 'left',
                backgroundColor: activeTab === index ? '#0d9488' : 'transparent', // Teal for active
                color: activeTab === index ? 'white' : '#6b7280',
                '&:hover': {
                  backgroundColor: activeTab === index ? '#0f766e' : '#f3f4f6',
                },
                borderRadius: '8px',
                px: 2,
                py: 1.5,
                mb: 1,
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: activeTab === index ? 600 : 400,
              }}
            >
              {tab.label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Main Content Area */}
      <Box sx={{ flex: 1 }}>
        {tabs.map((tab, index) => (
          <TabPanel key={index} value={activeTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default Settings;